import { z } from 'zod';
import { nullableList } from '../../zod-helpers';

const uuid = z.string().uuid();

export const returnStateSchema = z.enum([
  'requested',
  'approved',
  'received',
  'rejected',
  'refunded',
]);
export type ReturnState = z.infer<typeof returnStateSchema>;

export const returnRowSchema = z.object({
  id: uuid,
  order_id: uuid,
  order_short_code: z.string().nullable().optional(),
  user_id: uuid.nullable().optional(),
  reason: z.string().nullable().optional(),
  state: returnStateSchema,
  created_at: z.string().nullable().optional(),
  resolved_at: z.string().nullable().optional(),
  rejection_reason: z.string().nullable().optional(),
});
export type ReturnRow = z.infer<typeof returnRowSchema>;
export const returnListSchema = nullableList(returnRowSchema);

export const returnListFiltersSchema = z.object({
  state: returnStateSchema.optional(),
  limit: z.number().int().min(1).max(200).optional(),
});
export type ReturnListFilters = z.infer<typeof returnListFiltersSchema>;

export const returnRejectBodySchema = z.object({
  reason: z.string().min(1).max(500),
});
export type ReturnRejectBody = z.infer<typeof returnRejectBodySchema>;
